/**
 * Event
 * Create a single event entity
 *
 * @todo Background colour is dependant on .section__events .event__wrapper--row-wrapper .event__row - probably should not be.
 * @todo link is empty so assume I would use the slug to navigate to the events template, but there is no events template?
 * @todo This is quite nasty - really should have Grid components
 * @todo Check that end date exists - getting Invalid time on some contentful
 */
import React, { useMemo } from 'react'

import { IGatsbyImageData } from 'gatsby-plugin-image'
import { FormatStartDate, Header } from '../..'
import { Image } from '../../Image/Image'
import { formatEventTimeDisplay } from '../../utils'
import { AugmentedEvent } from '../../../utils/contentful-events'

export type EventImage = {
  gatsbyImageData: IGatsbyImageData
  title: string
}

export type EventProps = AugmentedEvent & {
  image: EventImage
}

export type EventRenderLinkProps = Partial<EventProps>

export type EventRenderImageProps = Partial<EventImage>

const EventListingLink = ({ children, url }: EventRenderLinkProps) => (
  <a href={url} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
)

const EventListingImage = ({ gatsbyImageData }: EventRenderImageProps) => (
  <Image gatsbyImageData={gatsbyImageData} isDecorative />
)

export const EventListing = (props: EventProps) => {
  const {
    eventType,
    endDate,
    image,
    startDate,
    timeZoneAbbreviation,
    title,
    isWebinar
  } = props

  const altTextEventType = isWebinar ? 'webinar' : 'event'

  const isMultiDays = (startDate: string, endDate: string) => {
    const startTime = new Date(startDate).getTime() / 1000
    const endTime = new Date(endDate).getTime() / 1000
    return endTime - startTime >= 86400
  }
  const eventEndDate = endDate || ''

  const timeDisplay = useMemo(
    () => formatEventTimeDisplay(startDate, endDate, timeZoneAbbreviation),
    [startDate, endDate, timeZoneAbbreviation]
  )

  return (
    <div className="frw-event__row frw-column__three frw-column--merge-a">
      <div className="frw-column frw-column--1">
        <div className="frw-event__date">
          <div className="frw-heading--6">
            {isMultiDays(startDate, eventEndDate) ? (
              <>
                {FormatStartDate(startDate)} -{' '}
                <div>{FormatStartDate(eventEndDate)}</div>
              </>
            ) : (
              FormatStartDate(startDate)
            )}
          </div>

          <p>{timeDisplay}</p>
        </div>
      </div>

      <div className="frw-column frw-column--2">
        <div className="frw-image-wrapper">
          <EventListingLink {...props}>
            <EventListingImage
              {...image}
              title={`Thumbnail for ${altTextEventType} titled ${title}`}
            />
          </EventListingLink>
        </div>
      </div>

      <div className="frw-column frw-column--3">
        <Header level={3} className="frw-event__title">
          <EventListingLink {...props}>{title}</EventListingLink>
        </Header>

        <p className="frw-event__location">{eventType}</p>
      </div>
    </div>
  )
}
export default EventListing
